import * as React from 'react';
import { UIText1, UIHeading2 } from '@cian/ui-kit/typography';
import { ConditionalWrapper } from '@cian/conditional-component';
import { UIHeading3, useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

import * as styles from './styles.css';

export interface IQuizCompletedProps {
  title: string;
  subtitle: string | null;
  footer?: React.ReactElement | null;
  img: React.ReactElement;
  isChatOpen?: boolean;
}

export const QuizCompletedSuccess: React.FC<React.PropsWithChildren<IQuizCompletedProps>> = props => {
  const { title, subtitle, footer, img, isChatOpen } = props;
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  return (
    <div className={styles['wrapper']} data-testid="success">
      <div className={cn(styles['container'], styles[deviceType])}>
        <div className={cn(styles['image'], styles[deviceType])}>{img}</div>
        <div className={styles['title']}>
          <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading2} ElseComponent={UIHeading3}>
            {title}
          </ConditionalWrapper>
        </div>
        {subtitle && (
          <div className={styles['text']}>
            <UIText1 color="current_color">{subtitle}</UIText1>
          </div>
        )}
        {footer && (
          <div
            className={cn(styles['footer'], styles[deviceType], isChatOpen && styles['chat-action'])}
            data-testid="footer"
          >
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

QuizCompletedSuccess.displayName = 'QuizCompletedSuccess';
